import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import { ThemeContext } from 'utils/theme';
import { sizes } from 'utils/detection';
// import { appState } from 'utils/appState';
import ProcessStepModel from 'models/ProcessStep';

import Wrapper from './styled/Wrapper';
import ItemNumber from './styled/ItemNumber';
import ItemWrapper from './styled/ItemWrapper';
import Subtitle from './styled/Subtitle';
import Title from './styled/Title';

export default class ProcessSlider extends Component {

  static defaultProps = {};

  static contextType = ThemeContext;

  afterIndexChange = () => {
    // if(appState.analytics)appState.analytics._trackEvent('ProcessPage', 'change slide');
  };

  render() {
    const { className, steps } = this.props;

    const sliderSettings = {
      arrows: false,
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 2.5,
      slidesToScroll: 1 - 0.5 / 9,
      initialSlide: 0,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: sizes.medium,
          settings: {
            initialSlide: 0.15,
            slidesToShow: 1.25,
            slidesToScroll: 0.99,
          }
        }
      ]
    };

    return (
      <Wrapper className={className}>
        <Slider {...sliderSettings} afterChange={this.afterIndexChange}>
          {steps.map((process, index) => (
            <ItemWrapper key={process.heading}>
              <ItemNumber>{index + 1 < 10 ? `0${index + 1}` : index}</ItemNumber>
              <Title theme={this.context}>{process.heading}</Title>
              <Subtitle theme={this.context}>{process.text}</Subtitle>
            </ItemWrapper>
          ))}
        </Slider>
      </Wrapper>
    );
  }
}
